import { memberGQLFields } from '../network/index.js';
import { postGQLFields, tagGQLFields, } from '../post/index.js';
import { spaceGQLFields } from '../space/index.js';
const BASIC_REPORTABLE_ENTITY_FIELDS = {};
const ALL_REPORTABLE_ENTITY_FIELDS = {
    onMember: 'basic',
    onPost: 'basic',
    onSpace: 'basic',
    onTag: 'basic',
};
export function reportableEntityGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_REPORTABLE_ENTITY_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORTABLE_ENTITY_FIELDS;
    return `
    __typename
    ${fields.onMember
        ? `
      ... on Member {
        ${memberGQLFields(fields.onMember)}
      }
    `
        : ``}
    ${fields.onPost
        ? `
      ... on Post {
        ${postGQLFields(fields.onPost)}
      }
    `
        : ``}
    ${fields.onSpace
        ? `
      ... on Space {
        ${spaceGQLFields(fields.onSpace)}
      }
    `
        : ``}
    ${fields.onTag
        ? `
      ... on Tag {
        ${tagGQLFields(fields.onTag)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=reportableEntity.fields.js.map